import React, { useEffect, useMemo } from 'react';
import './styles.css';
import { Route, Switch } from 'react-router-dom';
import { Role } from '../../helpers/user';
import NotFoundPage from '../NotFoundPage';
import { SignupContextProvider } from './context';
import SignupIndex from './pages';
import SignupFirm from './pages/firm';
import SignupSchool from './pages/school';
import SignupStepEight from './pages/step-eight';
import SignupStepFive from './pages/step-five';
import SignupStepFour from './pages/step-four';
import SignupStepOne from './pages/step-one';
import SignupStepSeven from './pages/step-seven';
import SignupStepSix from './pages/step-six';
import SignupStepThree from './pages/step-three';
import SignupStepTwo from './pages/step-two';
import SignupSuccess from './pages/success';

const SignupPage = props => {
  const [isGuest] = useMemo(() => [Role.isGuest(props.user)], [props.user]);

  useEffect(() => {
    if (props.user.isLoggedIn && !isGuest) {
      props.history.push('/platform');
    }
  }, [isGuest, props.history, props.user.isLoggedIn]);

  return (
    <SignupContextProvider>
      {props.user.isLoggedIn && isGuest && (
        <Switch>
          <Route exact path={'/signup/step/2'}>
            <SignupStepTwo {...props} />
          </Route>
          <Route exact path={'/signup/step/3'}>
            <SignupStepThree {...props} />
          </Route>
          <Route exact path={'/signup/step/4'}>
            <SignupStepFour {...props} />
          </Route>
          <Route exact path={'/signup/step/5'}>
            <SignupStepFive {...props} />
          </Route>
          <Route exact path={'/signup/step/6'}>
            <SignupStepSix {...props} />
          </Route>
          <Route exact path={'/signup/step/7'}>
            <SignupStepSeven {...props} />
          </Route>
          <Route exact path={'/signup/step/8'}>
            <SignupStepEight {...props} />
          </Route>
          <Route exact path={'/signup/success'}>
            <SignupSuccess {...props} />
          </Route>
          <Route>
            <NotFoundPage {...props} />
          </Route>
        </Switch>
      )}
      {!props.user.isLoggedIn && (
        <Switch>
          <Route exact path={'/signup'}>
            <SignupIndex {...props} />
          </Route>
          <Route exact path={'/signup/firm'}>
            <SignupFirm {...props} />
          </Route>
          <Route exact path={'/signup/school'}>
            <SignupSchool {...props} />
          </Route>
          <Route exact path={'/signup/step/1'}>
            <SignupStepOne {...props} />
          </Route>
          <Route>
            <NotFoundPage {...props} />
          </Route>
        </Switch>
      )}
    </SignupContextProvider>
  );
};

export default SignupPage;
